export default "__VITE_ASSET__CYRqBwMX__"